import { RequestTypeEnum } from "@nlc/shared-types";

/**
 * Configuration mapping for request type display titles
 * Used across SuperAdmin tables to ensure consistent naming
 */
export const REQUEST_TYPE_TITLES = {
  [RequestTypeEnum.GRAPHIC]: "Graphic",
  [RequestTypeEnum.VIDEO]: "Video",
  [RequestTypeEnum.WEBSITE_DESIGN]: "Web design",
  [RequestTypeEnum.WEBSITE_IMPLEMENTATION]: "Web Implementation",
} as const;

export type RequestTypeTitle =
  (typeof REQUEST_TYPE_TITLES)[keyof typeof REQUEST_TYPE_TITLES];

/**
 * Get display title for a request type
 * @param requestType - The request type enum value
 * @returns The display title for the request type
 */
export function getRequestTypeTitle(requestType: RequestTypeEnum): string {
  return (
    REQUEST_TYPE_TITLES[requestType as keyof typeof REQUEST_TYPE_TITLES] ||
    requestType
  );
}

/**
 * All supported request types for SuperAdmin views
 */
export const SUPERADMIN_REQUEST_TYPES = [
  RequestTypeEnum.GRAPHIC,
  RequestTypeEnum.VIDEO,
  RequestTypeEnum.WEBSITE_DESIGN,
  RequestTypeEnum.WEBSITE_IMPLEMENTATION,
] as const;

export type SuperAdminRequestType = (typeof SUPERADMIN_REQUEST_TYPES)[number];
